var render = function render(){var _vm=this,_c=_vm._self._c;return _c('pui-flex',{class:{ 'pui-error pui-error__root': true, 'pos-fixed': _vm.position === 'fixed' },attrs:{"direction":"column","alignItems":"center","justifyContent":"center"}},[(_vm.picto)?_c('i',{class:{ 'pui-error__error-icon mdi': true, [_vm.picto]: !!_vm.picto }}):_vm._e(),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }